import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { DataserviceService } from '../dataservice.service';
import { AppComponent } from '../app.component';

@Component({
  selector: 'app-providers',
  templateUrl: './providers.component.html',
  styleUrl: './providers.component.css'
})
export class ProvidersComponent {

  isModalVisible: boolean = false;
  loading: boolean = false;
  providerForm: FormGroup;
  providers: any;
  providersList: any;
  bgEmails: any[] = [];
  contactEmails: any[] = [];

  constructor(
    private nzNotify: NzNotificationService,
    private data: DataserviceService,
    private app: AppComponent
  ) {
    
    this.providerForm = new FormGroup({
      id: new FormControl(null),
      name: new FormControl(null, [Validators.required]),
      primary_name: new FormControl(null),
      primary_phone: new FormControl(null),
      primary_email: new FormControl(null, [Validators.email]),
      bg_emails: new FormControl(''),
      contact_emails: new FormControl(''),
      promo: new FormControl(null),
      promo_link: new FormControl(null)
    });

  }

  ngOnInit() {
    this.loading = true;
    this.getProviders();
  }

  isValidEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  addBgEmail() {
    const value = this.providerForm.get('bg_emails')?.value;
    if (value && this.isValidEmail(value) && !this.bgEmails.includes(value)) {
      this.bgEmails.push(value);
      this.providerForm.get('bg_emails')?.reset();
    }
  }

  removeBgEmail(chip: any) {
    this.bgEmails = this.bgEmails.filter((c: any) => c !== chip);
  }

  addContactEmail() {
    const value = this.providerForm.get('contact_emails')?.value;
    if (value && this.isValidEmail(value) && !this.contactEmails.includes(value)) {
      this.contactEmails.push(value);
      this.providerForm.get('contact_emails')?.reset();
    }
  }

  removeContactEmail(chip: any) {
    this.contactEmails = this.contactEmails.filter((c: any) => c !== chip);
  }

  hasPermissions(permission: string): boolean {
    return this.app.hasPermission(permission)
  }

  getProviders() {
    this.data.getData('providers')
      .subscribe({
        next: (res: any) => {
          this.providers = res?.data || [];
          this.providersList = res?.data || [];
          this.loading = false;
        },
        error: (err: any) => {
          console.log('err from getProviders: ', err)
          this.errorNotification('Failed to get providers!');
        }
      })
  }

  search(event: any) {
    this.providersList = this.providers.filter((item: any) => {

      const name = item.name.toLowerCase();
      const contactName = item.primary_contact_name?.toLowerCase() || '';
      const contactPhone = item.primary_contact_phone?.toLowerCase() || '';
      const contactEmail = item.primary_contact_email?.toLowerCase() || '';
      const contactEmails = Array.isArray(item.contact_emails) ? item.contact_emails.join(',').toLowerCase() : '';

      return (
        name.includes(event.target.value.toLowerCase()) ||
        contactName.includes(event.target.value.toLowerCase()) || 
        contactPhone.includes(event.target.value.toLowerCase()) ||
        contactEmail.includes(event.target.value.toLowerCase()) ||
        contactEmails.includes(event.target.value.toLowerCase())
      );
    });
  }

  showModal(p: any) {
    if(this.hasPermissions('manage_providers')) {
      this.providerForm.reset();
      this.bgEmails = [];
      this.contactEmails = [];
      if(p) {
        this.providerForm.patchValue({
          id: p.id,
          name: p.name,
          primary_name: p.primary_contact_name,
          primary_phone: p.primary_contact_phone,
          primary_email: p.primary_contact_email,
          promo: p.promo,
          promo_link: p.promo_link
        });

        this.bgEmails = Array.isArray(p.bg_emails) ? p.bg_emails : [];
        this.contactEmails = Array.isArray(p.contact_emails) ? p.contact_emails : [];
      }
      this.isModalVisible = true;
    }
  }

  addProvider() {
    let obj = {
      name: this.providerForm.get('name')?.value,
      primary_contact_name: this.providerForm.get('primary_name')?.value,
      primary_contact_phone: this.providerForm.get('primary_phone')?.value,
      primary_contact_email: this.providerForm.get('primary_email')?.value,
      bg_emails: this.bgEmails,
      contact_emails: this.contactEmails,
      promo: this.providerForm.get('promo')?.value,
      promo_link: this.providerForm.get('promo_link')?.value
    }
    this.data.postData(obj, 'providers/save')
      .subscribe({
        next: (res: any) => {
          this.providers = res?.data || [];
          this.providersList = res?.data || [];
          this.isModalVisible = false;
          this.loading = false;
          this.successNotification('created');
        },
        error: (err: any) => {
          this.loading = false;
          this.errorNotification('Failed to add provider!')
        }
      })
  }

  editProvider() {
    let obj = {
      id: this.providerForm.get('id')?.value,
      name: this.providerForm.get('name')?.value,
      primary_contact_name: this.providerForm.get('primary_name')?.value,
      primary_contact_phone: this.providerForm.get('primary_phone')?.value,
      primary_contact_email: this.providerForm.get('primary_email')?.value,
      bg_emails: this.bgEmails,
      contact_emails: this.contactEmails,
      promo: this.providerForm.get('promo')?.value,
      promo_link: this.providerForm.get('promo_link')?.value
    }
    this.data.postData(obj, 'providers/save')
      .subscribe({
        next: (res: any) => {
          this.providers = res?.data || [];
          this.providersList = res?.data || [];
          this.isModalVisible = false;
          this.loading = false;
          this.successNotification('updated');
        },
        error: (err: any) => {
          this.loading = false;
          this.errorNotification('Failed to update provider!')
        }
      })
  }

  confirmAddEdit() {
    if(this.providerForm.valid) {
      this.loading = true;
      if(this.providerForm.get('id')?.value) {
        this.editProvider()
      }else {
        this.addProvider()
      }
    }else {
      this.nzNotify.create(
        'warning',
        'Warning!',
        `Please fill out the required fields`,
        { nzPlacement: 'top' }
      );
    }
  }

  cancelAddEdit() {
    this.providerForm.reset();
    this.bgEmails = [];
    this.contactEmails = [];
    this.isModalVisible = false;
  }

  successNotification(str: string) {
    this.nzNotify.create(
      'success',
      'Success!',
      `Provider was ${str} successfully!`,
      { nzPlacement: 'top' }
    );
  }

  errorNotification(str: string) {
    this.nzNotify.create(
      'error',
      'Error!',
      str,
      { nzPlacement: 'top' }
    );
  }

}
